import * as React from 'react';

export interface IRtUiFormContextData {
	error?: any;
	isInline?: boolean;
}

export const RtUiFormContext = React.createContext<IRtUiFormContextData>({});
